import { NgModule } from '@angular/core';

import { IsNullPipe } from './is-null.pipe';

export * from './is-null.pipe';

@NgModule({
  declarations: [
    IsNullPipe,
  ],
  exports: [
    IsNullPipe,
  ]
})
export class BooleanPipesModule { }



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/boolean/index.ts